import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { ConfirmingReportPumpAndPoleItemListTemplate } from "themes/application/confirming-report/pages";
import { ConfirmingReportPumpAndPoleItemListViewStore } from "application/confirming-report/stores";

@setCurrentView(rootStore => new ConfirmingReportPumpAndPoleItemListViewStore(rootStore), "confirmingReportPumpAndPoleItemListViewStore")
@observer
class ConfirmingReportPumpAndPoleItemList extends React.Component {
    render() {
        return <ConfirmingReportPumpAndPoleItemListTemplate {...this.props} />;
    }
}

export default ConfirmingReportPumpAndPoleItemList;